module.exports = __webpack_public_path__ + "img/index_tree_light.56335f94.png";